import {React} from "react";

const NoPage = () => {
     return <h1>Ahhh!!!!! You found me with nothing to show!</h1>;
   };
   
   export default NoPage;